import { UserInfoActions, UserInfoActionTypes } from "src/store/actions/userInfo";

export interface UserInfo {
    annualEstimatedIncome: number;
}

const initialState: UserInfo = {
    annualEstimatedIncome: 0,
};

/**
 * A reducer that stores user information which is not persisted in Deal Person
 * @param state
 * @param action
 */
function userInfo(state: UserInfo = initialState, action: UserInfoActions): UserInfo {
    switch (action.type) {
        case UserInfoActionTypes.UPDATE_ANNUAL_ESTIMATED_INCOME:
            return { ...state, annualEstimatedIncome: action.data };
        default:
            return state;
    }
}

export default userInfo;
